module.exports = __webpack_public_path__ + "img/logo1.b537a17d.png";